module.exports = __webpack_public_path__ + "static/img/A92.79e9e857.jpg";